module.exports = __webpack_public_path__ + "static/media/Jupiter.320a83a9.png";